module.exports = __webpack_public_path__ + "media/app/assets/races/human_female-f73eaddccc6395d2519e5722d1e47325.png";